"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Eleanor Vance",
  quote: "Premier Home Loans made our dream of owning a historic estate a reality. Their attention to detail and financial expertise is unmatched.",
  position: "Homeowner in Greenwich"
}, {
  author: "David Richardson",
  quote: "The transition from renting to owning was seamless. Their team provided the clarity and confidence we needed for such a significant investment.",
  position: "First-time Buyer"
}];
export default function ClientSuccessStories() {
  return <section data-section-id="242566" id="client-success-stories" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden flex items-center min-h-[70vh]">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-[0.05] select-none">
        <Quote className="w-[300px] h-[300px] md:w-[600px] md:h-[600px] text-primary" fill="currentColor" />
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10 w-full">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-16 lg:px-24">
                  <p className="text-2xl md:text-3xl lg:text-5xl font-serif italic font-medium leading-relaxed tracking-tight text-foreground">
                    "{testimonial.quote}"
                  </p>
                  <div className="mt-10 md:mt-14 flex flex-col items-center gap-1">
                    <div className="flex gap-1 mb-2">
                      {[...Array(5)].map((_, i) => <span key={i} className="text-secondary text-lg"></span>)}
                    </div>
                    <span className="text-lg md:text-xl font-default font-bold text-foreground tracking-wide uppercase">
                      {testimonial.author}
                    </span>
                    <span className="text-sm md:text-base font-sans text-muted-foreground font-medium">
                      {testimonial.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-3 mt-16 md:mt-24">
            <CarouselPrevious className="static transform-none m-0 size-12 rounded-md border-secondary/30 bg-transparent text-secondary hover:bg-secondary hover:text-primary-foreground transition-all duration-300 shadow-md" />
            <CarouselNext className="static transform-none m-0 size-12 rounded-md border-secondary/30 bg-transparent text-secondary hover:bg-secondary hover:text-primary-foreground transition-all duration-300 shadow-md" />
          </div>
        </Carousel>
      </div>
    </section>;
}